/*
 * Seaszn: password-page email signup, wired directly to a Klaviyo list via
 * Klaviyo's public client-side Subscribe API (no app install required).
 *
 * <seaszn-klaviyo-form
 *   data-public-key="..."   (Klaviyo public API key / company ID — safe to expose client-side)
 *   data-list-id="..."      (Klaviyo list ID to subscribe the profile to)
 *   data-success-text="..."
 *   data-error-text="..."
 * >
 *   <form>...email input + submit button...</form>
 * </seaszn-klaviyo-form>
 */
if (!customElements.get('seaszn-klaviyo-form')) {
  customElements.define(
    'seaszn-klaviyo-form',
    class SeasznKlaviyoForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.message = this.querySelector('.seaszn-klaviyo-form__message');
        this.submitButton = this.querySelector('button[type="submit"]');
        this.publicKey = (this.getAttribute('data-public-key') || '').trim();
        this.listId = (this.getAttribute('data-list-id') || '').trim();

        if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      onSubmit(event) {
        event.preventDefault();

        if (!this.publicKey || !this.listId) {
          this.showMessage("This signup form isn't connected to a Klaviyo list yet — add your public API key and list ID in the theme editor.", true);
          return;
        }

        const emailInput = this.form.querySelector('input[type="email"]');
        const email = emailInput ? emailInput.value.trim() : '';
        if (!email) return;

        this.setLoading(true);

        fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.publicKey)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-10-15',
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: email },
                  },
                },
              },
              relationships: {
                list: {
                  data: { type: 'list', id: this.listId },
                },
              },
            },
          }),
        })
          .then((response) => {
            this.setLoading(false);
            if (response.ok) {
              this.form.reset();
              this.showMessage(this.getAttribute('data-success-text') || "You're on the list.", false);
            } else {
              this.showMessage(this.getAttribute('data-error-text') || 'Something went wrong — please try again.', true);
            }
          })
          .catch(() => {
            this.setLoading(false);
            this.showMessage(this.getAttribute('data-error-text') || 'Something went wrong — please try again.', true);
          });
      }

      setLoading(isLoading) {
        if (this.submitButton) this.submitButton.disabled = isLoading;
        this.classList.toggle('loading', isLoading);
      }

      showMessage(text, isError) {
        if (!this.message) return;
        this.message.textContent = text;
        this.message.hidden = false;
        this.message.classList.toggle('seaszn-klaviyo-form__message--error', !!isError);
      }
    }
  );
}
